/* Mold Labs — cookie consent bar.
   Self-contained, builds its own DOM and paints directly on elements so the
   store's style-stripping can't zero it out. Stores choice in localStorage.
   Config comes from window.MLCookie (set inline by ml-header.liquid). */
(function () {
  var CFG = window.MLCookie || {};
  if (CFG.enabled === false) { return; }
  var KEY = 'ml-cookie-consent-v1';

  var GREEN = '#5ccc78', GREEN_INK = '#2f9c57', INK = '#0f0f0e';
  var BODY = '#5a5a52', SURFACE = '#ffffff', LINE = '#ecece5';

  function getConsent() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }

  /* ---- Shopify Customer Privacy (real tracking gate) ----
     Passes the visitor's choice to Shopify so GA / Meta Pixel / marketing
     pixels are actually withheld until consent. Safe no-op if the API isn't
     present (e.g. Customer Privacy not enabled) so the bar still works. */
  function shopifyPrivacy() {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) { return window.Shopify.customerPrivacy; }
    } catch (e) {}
    return null;
  }
  function applyTrackingConsent(val) {
    var api = shopifyPrivacy();
    if (!api || typeof api.setTrackingConsent !== 'function') { return; }
    var granted = (val === 'all');
    var consent = {
      analytics: granted,
      marketing: granted,
      preferences: granted,
      sale_of_data: granted ? 'yes' : 'no'
    };
    try {
      api.setTrackingConsent(consent, function () {});
    } catch (e) {
      // older signature: (bool, cb)
      try { api.setTrackingConsent(granted, function () {}); } catch (e2) {}
    }
  }

  function setConsent(val) {
    try { localStorage.setItem(KEY, JSON.stringify({ v: val, t: Date.now() })); } catch (e) {}
    applyTrackingConsent(val);
    document.dispatchEvent(new CustomEvent('ml:cookie-consent', { detail: val }));
  }

  function css(el, styles) { for (var k in styles) { el.style[k] = styles[k]; } return el; }

  function mono(size, color) {
    return {
      fontFamily: "'Space Mono', ui-monospace, monospace",
      fontSize: size, letterSpacing: '.14em', textTransform: 'uppercase', color: color
    };
  }

  function build() {
    if (document.querySelector('[data-ml-cookie]')) { return; }

    var wrap = document.createElement('div');
    wrap.setAttribute('data-ml-cookie', '');
    css(wrap, {
      position: 'fixed', left: '0', right: '0', bottom: '0', zIndex: '2147483000',
      display: 'flex', justifyContent: 'center', padding: '0 16px 16px',
      boxSizing: 'border-box', pointerEvents: 'none',
      fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif"
    });

    var card = document.createElement('div');
    css(card, {
      pointerEvents: 'auto', width: '100%', maxWidth: '820px', boxSizing: 'border-box',
      background: SURFACE, border: '1px solid ' + LINE, borderRadius: '16px',
      boxShadow: '0 18px 44px rgba(15,15,14,.16)', padding: '20px 24px',
      display: 'flex', alignItems: 'center', gap: '22px', flexWrap: 'wrap',
      transform: 'translateY(24px)', opacity: '0',
      transition: 'transform .5s cubic-bezier(.22,1,.36,1), opacity .4s ease'
    });

    // green mark
    var markWrap = document.createElement('div');
    css(markWrap, { flex: '0 0 auto', display: 'flex', alignItems: 'center', gap: '13px', minWidth: '0' });
    var mark = document.createElement('div');
    css(mark, {
      width: '38px', height: '38px', flex: '0 0 38px', borderRadius: '10px', background: GREEN,
      display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3.5px', padding: '6px', boxSizing: 'border-box', alignContent: 'center'
    });
    for (var i = 0; i < 4; i++) {
      var dot = document.createElement('i');
      css(dot, { display: 'block', width: '100%', paddingBottom: '100%', borderRadius: '50%', background: GREEN_INK });
      mark.appendChild(dot);
    }
    markWrap.appendChild(mark);

    // text block
    var textCol = document.createElement('div');
    css(textCol, { flex: '1 1 300px', minWidth: '0' });
    var eyebrow = document.createElement('div');
    css(eyebrow, mono('10px', GREEN_INK));
    eyebrow.style.marginBottom = '6px';
    eyebrow.textContent = CFG.eyebrow || 'Cookies';
    var body = document.createElement('div');
    css(body, { fontSize: '13.5px', lineHeight: '1.55', color: BODY });
    body.innerHTML = (CFG.text || 'Používáme cookies pro fungování webu a — s vaším souhlasem — pro analýzu a lepší zážitek z nákupu.');
    var linkCss = 'color:' + INK + ';font-weight:600;text-decoration:none;border-bottom:2px solid ' + GREEN + ';white-space:nowrap;';
    if (CFG.policyUrl) {
      body.innerHTML += ' <a href="' + CFG.policyUrl + '" style="' + linkCss + '">' + (CFG.policyLabel || 'Více informací') + '</a>';
    }
    // Google cookies policy link (defaults on unless explicitly set to empty). Like fabini.cz.
    if (CFG.googleUrl !== '') {
      var gUrl = CFG.googleUrl || 'https://business.safety.google/intl/cs/privacy/';
      var gLabel = CFG.googleLabel || 'Cookies Google';
      var sep = CFG.policyUrl ? ' · ' : ' ';
      body.innerHTML += sep + '<a href="' + gUrl + '" target="_blank" rel="noopener noreferrer" style="' + linkCss + '">' + gLabel + '</a>';
    }
    textCol.appendChild(eyebrow);
    textCol.appendChild(body);

    // buttons
    var btns = document.createElement('div');
    css(btns, { flex: '0 0 auto', display: 'flex', gap: '10px', alignItems: 'center' });

    var decline = document.createElement('button');
    decline.type = 'button';
    css(decline, {
      appearance: 'none', border: '1px solid #d6d6cd', background: 'transparent',
      color: INK, borderRadius: '10px', padding: '13px 20px', fontSize: '14px', fontWeight: '600',
      cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap', transition: 'border-color .18s ease'
    });
    decline.textContent = CFG.declineLabel || 'Jen nezbytné';
    decline.onmouseenter = function () { decline.style.borderColor = INK; };
    decline.onmouseleave = function () { decline.style.borderColor = '#d6d6cd'; };

    var accept = document.createElement('button');
    accept.type = 'button';
    css(accept, {
      appearance: 'none', border: 'none', background: INK, color: '#fff',
      borderRadius: '10px', padding: '14px 24px', fontSize: '14px', fontWeight: '600',
      cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap', transition: 'background .18s ease'
    });
    accept.textContent = CFG.acceptLabel || 'Přijmout vše';
    accept.onmouseenter = function () { accept.style.background = GREEN_INK; };
    accept.onmouseleave = function () { accept.style.background = INK; };

    btns.appendChild(decline);
    btns.appendChild(accept);

    card.appendChild(markWrap);
    card.appendChild(textCol);
    card.appendChild(btns);
    wrap.appendChild(card);
    document.body.appendChild(wrap);

    // enter animation
    setTimeout(function () { card.style.transform = 'translateY(0)'; card.style.opacity = '1'; }, 30);

    function dismiss(val) {
      setConsent(val);
      card.style.transform = 'translateY(24px)';
      card.style.opacity = '0';
      setTimeout(function () { if (wrap.parentNode) { wrap.parentNode.removeChild(wrap); } }, 420);
    }
    accept.addEventListener('click', function () { dismiss('all'); });
    decline.addEventListener('click', function () { dismiss('necessary'); });

    // responsive: keep it a compact bar on mobile (don't blow up to full-height)
    function fit() {
      var narrow = window.innerWidth < 560;
      if (narrow) {
        css(card, { flexDirection: 'column', alignItems: 'stretch', gap: '11px', padding: '13px 15px', borderRadius: '14px' });
        markWrap.style.display = 'none';                 // drop the logo mark to save room
        css(textCol, { flex: '1 1 auto' });
        eyebrow.style.display = 'none';                  // eyebrow off; keep just the sentence
        css(body, { fontSize: '11.5px', lineHeight: '1.4' });
        css(btns, { flex: '0 0 auto', flexDirection: 'row', gap: '8px', width: '100%' });
        css(accept, { flex: '1', padding: '10px 12px', fontSize: '12.5px', borderRadius: '9px' });
        css(decline, { flex: '1', padding: '10px 12px', fontSize: '12.5px', borderRadius: '9px' });
        wrap.style.padding = '0 10px 10px';
      } else {
        css(card, { flexDirection: 'row', alignItems: 'center', gap: '22px', padding: '20px 24px', borderRadius: '16px' });
        markWrap.style.display = 'flex';
        eyebrow.style.display = 'block';
        css(body, { fontSize: '13.5px', lineHeight: '1.55' });
        css(btns, { flexDirection: 'row', gap: '10px', width: 'auto' });
        css(decline, { flex: '0 0 auto', padding: '13px 20px', fontSize: '14px', borderRadius: '10px' });
        css(accept, { flex: '0 0 auto', padding: '14px 24px', fontSize: '14px', borderRadius: '10px' });
        wrap.style.padding = '0 16px 16px';
      }
    }
    fit();
    window.addEventListener('resize', fit);
  }

  function init() {
    // If the visitor already made a choice (ours), don't show — but re-apply it
    // to Shopify in case its per-session state was reset.
    var stored = getConsent();
    if (stored) { applyTrackingConsent(stored.v); return; }

    // Respect an existing Shopify consent decision so we don't double-prompt.
    // shouldShowBanner() is true only when consent is still required + undecided.
    var api = shopifyPrivacy();
    if (api && typeof api.shouldShowBanner === 'function') {
      try { if (!api.shouldShowBanner()) { return; } } catch (e) {}
    }
    build();
  }

  // expose a way to reopen (e.g. a "Nastavení cookies" footer link with href="#ml-cookies")
  window.MLCookieReopen = function () {
    try { localStorage.removeItem(KEY); } catch (e) {}
    var existing = document.querySelector('[data-ml-cookie]');
    if (existing && existing.parentNode) { existing.parentNode.removeChild(existing); }
    build();
  };
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#ml-cookies"]');
    if (a) { e.preventDefault(); window.MLCookieReopen(); }
  });

  // Shopify loads its privacy API asynchronously; wait briefly for it if present
  // so the first pageview's consent is honored, but never block the bar for long.
  function boot() {
    if (shopifyPrivacy()) { init(); return; }
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (shopifyPrivacy() || tries > 20) { clearInterval(iv); init(); }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
